import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function PenStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M16.1025 3.84962C16.7899 3.28895 17.8036 3.32901 18.4443 3.96974L20.0303 5.55567L20.1504 5.68849C20.6735 6.33004 20.6736 7.25597 20.1504 7.89747L20.0303 8.03028L9.1289 18.9316C8.77647 19.284 8.33484 19.5334 7.85155 19.6543L4.38866 20.5205C4.13319 20.5843 3.86297 20.5094 3.67675 20.3233C3.49056 20.1371 3.41575 19.8668 3.47948 19.6113L4.34472 16.1484L4.39648 15.9688C4.53012 15.5557 4.76012 15.1794 5.06835 14.8711L15.9697 3.96974L16.1025 3.84962ZM6.1289 15.9316C6.0088 16.0518 5.91516 16.1949 5.85253 16.3516L5.7998 16.5117L5.2373 18.7617L7.4873 18.1992L7.64843 18.1475C7.80515 18.0848 7.94825 17.9911 8.06835 17.8711L16.1465 9.79298L14.207 7.85352L6.1289 15.9316ZM17.3838 5.03028C17.2984 4.94486 17.1663 4.93398 17.0693 4.99806L17.0303 5.03028L15.2676 6.79298L17.207 8.73243L18.9697 6.96974L19.0019 6.93067C19.0568 6.84754 19.0568 6.73846 19.0019 6.65528L18.9697 6.61622L17.3838 5.03028Z"
				fill="currentColor"
			/>
		</svg>
	);
}

PenStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default PenStrokeIcon;
